const getDataFromResponse = (response) => response?.data;

export default getDataFromResponse;
